export const PRIZES_SECTION_ID = "ticketing-prizes";
export const getPrizeCardElementId = (prizeId: string) => `ticketing-prize-${prizeId}`;

export const MAX_LARGE_DESKTOP_PRIZES = 3;
